<template>
    <div id="content" class="chart-container" style="margin-top: 100px;">
        <chart height="1000px" width="100%"/>
        <div class="major" style="margin-left: -300px">
            <p class="major_ad">高精准的广告投放 & 更专业的流量变现</p>
            <P class="massive_users">海量用户数据为合作媒体赋能，丰富广告资源让流量变现更简单</P>
        </div>
    </div>
</template>

<script>
    import Chart from '@/charts/LineMarker.vue'

    export default {
        name: 'LaIntroduce',
        components: { Chart }
    }
</script>

<style scoped>
    .chart-container{
        position: relative;
        width: 100%;
        height: 100%;
    }
    .major{
        position: absolute;
        top: 200px;
        left: 800px;
        width: 698px;
        height: 183px;
    }
    .major_ad{
        font-size: 40px;
        font-weight:bold
    }
    .massive_users{
        font-size: 18px;
        color: #fff;
        text-align: center;
    }
</style>

